<!-- UniDate: Universal Date Input Component -->

<template>
	<div class="unidate-main">

		<DatePicker 
			:mode="mode"
			:is-inline="true"
			:attributes="atts"
			v-model="selectedDate"
			@dayclick="clickDate"
		/>

		<div class="v-spacer"></div>

		<div class="save-box wi8_font" @click="clickSave">
			<div class="label">
				OK
			</div>
			<div class="btn-box">
				<UniIcon 
					ico="check"
					fit="1"
					color="#090"
				/>
			</div>
		</div>

	</div>
</template>

<script>
import { m } from "@/utils/utils";
import * as Utils from "@/utils/utils"
import CfgApp from "@/assets/cfg/CfgApp";
import { mapState, mapGetters } from "vuex";
import { eventBus } from '@/main';
import Vue from "vue";
import Calendar from 'v-calendar/lib/components/calendar.umd'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

export default {
	components: {
	    Calendar,
	    DatePicker,
	},
	data() {
		return {
			selectedDate: new Date(),
			txtDate: "",
			mode: "single",
			atts: [
				// {
				// key: "current",
				// highlight: true,
				// dates: new Date(),
				// },
			],
		}
	},
	props: {
		compData: { type: Object, default: function () {return {}} },
	},
	methods: {
		goTest() {
			m("uni date: go test");
		},
  		day(){
			  m(arguments);
		},
		clickDate(day) {
			m("click day", day);
			m("id", day.id);
			this.txtDate = day.id + " 00:00:00";
		},
		goClose() {
			m("uni date: go close");	
			eventBus.$emit("popoff");
		},
		clickSave() {
			m("uni date: click save", this.txtDate);
			const payload = {
				colName: this.compData.colName,
				val: this.txtDate.substr(0,10),
			}
			eventBus.$emit('update-value', payload);
			
			this.goClose(); // Close if popup
			
		},
		goInit() {
			m("uni date: go init", this.compData);
			this.txtDate = this.compData.defaultVal || "";

			if (this.txtDate.length==10) {
				this.txtDate = this.txtDate.substr(0,10) + " 00:00:00";
				this.selectedDate = new Date(this.txtDate);
			}

			this.txtDate = this.selectedDate.toISOString().slice(0,10) + " 00:00:00";
			m("selectedDate", this.selectedDate);

		},
		handleKey(evt) {
			m("uni date: handle key: " + evt.key, this.txtVal);
			if (evt.key && evt.key.indexOf('Ent')===0 && !this.compData.multiLine) {
				this.clickSave();
			}
		},
	},
	created() {
		m("uni date: created", this.compData);
		window.addEventListener("keydown", this.handleKey);
		this.goInit();
	},
	beforeDestroy() {
		m("uni date: bef destroy");
		window.removeEventListener("keydown", this.handleKey);
	},
	mounted() {
		m("uni date: mounted");
	},
}
</script>

<style scoped>

.unidate-main {
	height: 100%;
	overflow: hidden;
	padding: 0px 0px 0px 20px;
	border: solid 0px #C30;
}

.v-spacer {
	width: 10px;
	height: 10px;
	overflow: hidden;
	border: solid 0px #C30;
}

.save-box {
	width: 80px;
	height: 40px;
	overflow: hidden;
	cursor: pointer;
	background-color: #FFF;
	border-radius: 5px;
	border: solid 2px #369;
}

.label {
	display: inline-block;
	width: 40px;
	overflow: hidden;
	padding: 10px 0px 0px 5px;
	border: solid 0px #C30;
}

.btn-box {
	float:right;
	width: 36px;
	height: 36px;
	overflow: hidden;
	cursor: pointer;
	border: solid 0px #C30;
}

</style>
